import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import "./SearchBar.css";

const SearchBar = ({ searchQuery, setSearchQuery, resultCount, placeholder }) => (
  <div className="search-bar-wrapper">
    <div className="search-bar-inner">
      <SearchIcon sx={{ fontSize: "16px", flexShrink: 0, color: "inherit" }} />
      <input
        type="text"
        className="search-input"
        placeholder={placeholder || "Rechercher..."}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      {searchQuery && (
        <button className="search-clear" onClick={() => setSearchQuery("")}>
          <ClearIcon sx={{ fontSize: "14px", display: "block" }} />
        </button>
      )}
    </div>
    {searchQuery && (
      <p className="search-results-count">
        {resultCount} résultat{resultCount !== 1 ? "s" : ""}
      </p>
    )}
  </div>
);

export default SearchBar;